// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._3ESRhfQ5YTjZnRgKsEuSNj {\n  position: relative;\n}\n\n._6tb4LIllJWjMWOEfzgpgp > * {\n  margin: 0 0.2em;\n}\n\n._2TxObx3MFYF-uMLxHD5wqB{\n  border: 0 !important;\n  outline: 0 !important;\n  margin-left: 5px;\n}\n._2LDmPFXGK9Aup1F3_DCjSA._26qOSC8SV5ImopgbcBRZ7W{\n  padding: 0;\n}", ""]);
// Exports
exports.locals = {
	"widget": "_3ESRhfQ5YTjZnRgKsEuSNj",
	"footerControls": "_6tb4LIllJWjMWOEfzgpgp",
	"widgetCollapseBtn": "_2TxObx3MFYF-uMLxHD5wqB",
	"panel-body": "_2LDmPFXGK9Aup1F3_DCjSA",
	"collapsed": "_26qOSC8SV5ImopgbcBRZ7W"
};
module.exports = exports;
